import { useApiClientBase } from "../api/apiClient";

/**
 * useUserApi is a custom hook that provides an API function
 * for fetching user profile information.
 * It uses the configured API client and error handler from useApiClientBase.
 *
 * @returns { getUser } - Function to fetch user profile information.
 */
export const useUserApi = () => {
  const { apiClient, handleError } = useApiClientBase();

  /**
   * Fetches user profile information from the backend API.
   *
   * @param params - (Optional) Query parameters to filter user data.
   * @returns {Promise<any>} - The response data containing user information, or null if an error occurs.
   */
  const getUser = async (params = {}) => {
    try {
      const response = await apiClient.get("/Users/GetUser", { params });
      return response.data;
    } catch (err) {
      return handleError(err, "fetching user data");
    }
  };

  return { getUser };
};
